// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-kYJ-","label":"styles_label__3RyII"};